import { jsxs as M, jsx as k } from "react/jsx-runtime";
import { useState as K, useEffect as V } from "react";
import $ from "case";
import { g } from "./Image-3okXnSA9.js";
const P = "#B1D366", Y = [
  "primaryPlayerColor",
  "elementButtonPrimaryPlayerDefault",
  "elementButtonPrimaryPlayerBorderDefault",
  "elementButtonPrimaryPlayerTextDefault",
  "elementButtonPrimaryPlayerHover",
  "elementButtonPrimaryPlayerBorderHover",
  "elementButtonPrimaryPlayerTextHover",
  "elementButtonPrimaryPlayerActive",
  "elementButtonPrimaryPlayerBorderActive",
  "elementButtonPrimaryPlayerTextActive",
  "elementButtonSecondaryPlayerDefault",
  "elementButtonSecondaryPlayerBorderDefault",
  "elementButtonSecondaryPlayerTextDefault",
  "elementButtonSecondaryPlayerHover",
  "elementButtonSecondaryPlayerBorderHover",
  "elementButtonSecondaryPlayerTextHover",
  "elementButtonSecondaryPlayerActive",
  "elementButtonSecondaryPlayerBorderActive",
  "elementButtonSecondaryPlayerTextActive",
  "playerBackgroundColor",
  "playerCardBackgroundColor",
  "playerGameplaySurfaceColor",
  "playerGameplayAccentColor",
  "playerGameplayObjectColor",
  "playerInteractiveElementColor",
  "playerContrastedCardColor",
  "playerSurfaceHoverColor",
  "playerMediaBackgroundColor",
  "playerFeedbackBackgroundColor",
  "playerMetaFeedbackBackgroundColor",
  "playerFeedbackBorderColor",
  "playerFeedbackPromptBorderColor",
  "playerTextColor",
  "playerTextColorSecondary",
  "playerDimmedTextColor",
  "playerAudioColor",
  "playerAudioIconColor",
  "playerAudioSelectedHoverColor",
  "playerAudioBorderColor",
  "playerHeaderCardBackgroundColor",
  "playerHeaderContainerBackgroundColor",
  "playerTooltipBackgroundColor",
  "playerTooltipTextColor",
  "playerUnopenedActivityColor",
  "playerOpenedActivityColor",
  "playerOpenedActivityDotColor",
  "playerClosedActivityColor",
  "playerCorrectColor",
  "playerIncorrectColor",
  "playerCorrectStrongColor",
  "playerIncorrectStrongColor",
  "playerCorrectHighlightColor",
  "playerIncorrectHighlightColor",
  "playerCorrectBackgroundColor",
  "playerIncorrectBackgroundColor",
  "playerCorrectStrongBackgroundColor",
  "playerIncorrectStrongBackgroundColor",
  "playerKidFeedbackModalityTextColor",
  "playerInputBackgroundColor",
  "playerInputHoverColor",
  "playerInputBorderColor",
  "playerInputFocusBorderColor",
  "playerInputUnderlineColor",
  "playerDropzoneColor",
  "playerDropzoneClickableColor",
  "playerDropzoneHoverColor",
  "playerDropzoneActiveColor",
  "playerDropzonePressColor",
  "playerFilledDropzoneHoverColor",
  "playerFilledDropzonePressColor",
  "playerTagBackgroundColor",
  "playerTagBorderColor",
  "playerTagActiveBorderColor",
  "playerTagPressColor",
  "playerInventoryPrimaryColor",
  "playerCardBorderRadius",
  "playerCardShadow",
  "playerCardPadding",
  "playerCardPaddingMobile",
  "playerContentMaxWidth",
  "playerOpenMargin",
  "playerOpenMarginMobile",
  "playerButtonFontSize",
  "playerButtonFontWeight",
  "playerButtonBorderRadius",
  "playerFeedbackFontWeight",
  "fontFamily",
  "fontSize",
  "playerFontSize",
  "playerHeaderFontSize",
  "playerFontWeight",
  "choiceOverlay",
  "choiceTextColor",
  "selectedChoiceColor",
  "selectedChoiceTextColor",
  "highlightColor1",
  "highlightColor2",
  "highlightColor3",
  "highlightColor4",
  "highlightColor5"
], L = {
  primaryPlayerColor: P,
  elementButtonPrimaryPlayerDefault: P,
  elementButtonPrimaryPlayerBorderDefault: P,
  elementButtonPrimaryPlayerTextDefault: "#47382F",
  elementButtonPrimaryPlayerHover: "#BFDB83",
  elementButtonPrimaryPlayerBorderHover: "#BFDB83",
  elementButtonPrimaryPlayerTextHover: "#47382F",
  elementButtonPrimaryPlayerActive: "#8DA851",
  elementButtonPrimaryPlayerBorderActive: "#8DA851",
  elementButtonPrimaryPlayerTextActive: "#47382F",
  elementButtonSecondaryPlayerDefault: "#ffffff",
  elementButtonSecondaryPlayerBorderDefault: "#ffffff",
  elementButtonSecondaryPlayerTextDefault: "#47382F",
  elementButtonSecondaryPlayerHover: "#ECF4DA",
  elementButtonSecondaryPlayerBorderHover: "#ECF4DA",
  elementButtonSecondaryPlayerTextHover: "#47382F",
  elementButtonSecondaryPlayerActive: "#CEE3A0",
  elementButtonSecondaryPlayerBorderActive: "#CEE3A0",
  elementButtonSecondaryPlayerTextActive: "#47382F",
  playerBackgroundColor: "#f2f7e2",
  playerCardBackgroundColor: "#ffffff",
  playerGameplaySurfaceColor: "#ffffff",
  playerGameplayAccentColor: "#3b29ab",
  playerGameplayObjectColor: "#6200ee",
  playerInteractiveElementColor: "#7b55e5",
  playerContrastedCardColor: "#fbfcf7",
  playerSurfaceHoverColor: "#e6e9da",
  playerMediaBackgroundColor: "#141414",
  playerFeedbackBackgroundColor: "#fafaf6",
  playerMetaFeedbackBackgroundColor: "#fff",
  playerFeedbackBorderColor: "#cdccc6",
  playerFeedbackPromptBorderColor: "#c8c8c3",
  playerTextColor: "#141414",
  playerTextColorSecondary: "#47382f",
  playerDimmedTextColor: "#8c837e",
  playerAudioColor: "#fbfcf7",
  playerAudioSelectedHoverColor: "#6a7e3d",
  playerAudioBorderColor: "#cdccc6",
  playerAudioIconColor: "#000000",
  playerHeaderCardBackgroundColor: "#fbfcf7",
  playerHeaderContainerBackgroundColor: "#ffffff",
  playerTooltipBackgroundColor: "#322f35",
  playerTooltipTextColor: "#f5eff7",
  playerUnopenedActivityColor: "#dcddda",
  playerOpenedActivityColor: "#b2d468",
  playerOpenedActivityDotColor: "#e0edc2",
  playerClosedActivityColor: "#8ab52d",
  playerCorrectColor: "#2b7d55",
  playerIncorrectColor: "#e34035",
  playerCorrectStrongColor: "#186a3a",
  playerIncorrectStrongColor: "#c81d1d",
  playerCorrectHighlightColor: "#186a3a40",
  playerIncorrectHighlightColor: "#c81d1d40",
  playerCorrectBackgroundColor: "#f6faf8",
  playerIncorrectBackgroundColor: "#fef9f9",
  playerCorrectStrongBackgroundColor: "#eaffeb",
  playerIncorrectStrongBackgroundColor: "#ffefef",
  playerKidFeedbackModalityTextColor: "#422300",
  playerInputBackgroundColor: "#f5f5f5",
  playerInputHoverColor: "#f7f2fe",
  playerInputBorderColor: "#7b7b7b",
  playerInputFocusBorderColor: "#6200ee",
  playerInputUnderlineColor: "#d8d8d8",
  playerDropzoneColor: "#f0f2fe",
  playerDropzoneClickableColor: "#eeecec",
  playerDropzoneHoverColor: "#d6d6d6",
  playerDropzoneActiveColor: "#e8ccfc",
  playerDropzonePressColor: "#cac1d8",
  playerFilledDropzoneHoverColor: "#b0a4b4",
  playerFilledDropzonePressColor: "#9a959f",
  playerTagBackgroundColor: "#ffffff",
  playerTagBorderColor: "#6a0ee5",
  playerTagActiveBorderColor: "#5900e6",
  playerTagPressColor: "#ddd6e5",
  playerInventoryPrimaryColor: "#e2dff2",
  playerCardBorderRadius: "15px",
  playerCardShadow: "1px 2px 5px 0px #00000040",
  playerCardPadding: "40px",
  playerCardPaddingMobile: "16px",
  playerContentMaxWidth: "1032px",
  playerOpenMargin: "30px",
  playerOpenMarginMobile: "16px",
  playerButtonFontSize: "1rem",
  playerButtonFontWeight: "500",
  playerButtonBorderRadius: "6px",
  playerFeedbackFontWeight: "700",
  fontFamily: "Roboto",
  fontSize: "16px",
  playerFontSize: "1rem",
  playerHeaderFontSize: "1rem",
  playerFontWeight: "400",
  choiceOverlay: "transparent",
  choiceTextColor: "black",
  selectedChoiceColor: "transparent",
  selectedChoiceTextColor: "black",
  highlightColor1: "#E747C4",
  highlightColor2: "#F56E00",
  highlightColor3: "#009CB8",
  highlightColor4: "#EBE00A",
  highlightColor5: "#9E9EFF"
};
var m = /* @__PURE__ */ ((e) => (e.Light = "light", e.Dark = "dark", e))(m || {});
const q = [
  "fontFamily",
  "fontSize",
  "pageHeaderTitleFontSize"
], J = [
  "primaryColor",
  "primaryColorDark",
  "defaultBlack",
  "defaultWhite",
  "blockHeader",
  "blockFooter",
  "blockPage",
  "contentPage",
  "block",
  "blockBorder",
  "blockItem1Default",
  "blockItem1Selected",
  "blockItem1SelectedTeacher",
  "blockItem1SelectedSubject1",
  "blockItem1SelectedSubject2",
  "blockItem1BorderDefault",
  "blockItem1BorderSelected",
  "blockItem2Default",
  "textMainDefault",
  "textMainOff",
  "textMainDisabled",
  "textMainInverted",
  "textH1ContentPageDefault",
  "textHeaderDefault",
  "textFooterDefault",
  "textSubject1Default",
  "textSubject1Off",
  "textSubject1Disabled",
  "textSubject2Default",
  "textSubject2Off",
  "textSubject2Disabled",
  "elementGrey10",
  "elementGrey20",
  "elementGrey50",
  "elementGrey80",
  "elementEvidencebDefault",
  "elementEvidencebDefaultLight",
  "elementEvidencebHover",
  "elementEvidencebDisabled",
  "elementEvidencebIdle",
  "elementEvidencebUnfocused",
  "elementTeacherDefault",
  "elementTeacherHover",
  "elementTeacherDisabled",
  "elementTeacherIdle",
  "elementTeacherUnfocused",
  "elementSubject1Default",
  "elementSubject1Hover",
  "elementSubject1Disabled",
  "elementSubject1Idle",
  "elementSubject1Unfocused",
  "elementSubject2Default",
  "elementSubject2Hover",
  "elementSubject2Disabled",
  "elementSubject2Idle",
  "elementSubject2Unfocused",
  "elementNavigationDefault",
  "elementNavigationHover",
  "elementNavigationDisabled",
  "elementButtonPrimaryDefault",
  "elementButtonPrimaryBorderDefault",
  "elementButtonPrimaryTextDefault",
  "elementButtonPrimaryHover",
  "elementButtonPrimaryBorderHover",
  "elementButtonPrimaryTextHover",
  "elementButtonSecondaryDefault",
  "elementButtonSecondaryBorderDefault",
  "elementButtonSecondaryTextDefault",
  "elementButtonSecondaryHover",
  "elementButtonSecondaryBorderHover",
  "elementButtonSecondaryTextHover",
  "elementButtonCustomHover",
  "elementTabPrimaryActiveTextDefault",
  "elementTabPrimaryActiveTextHover",
  "elementTabPrimaryActiveBorderDefault",
  "elementTabPrimaryInactiveDefault",
  "elementTabPrimaryInactiveHover",
  "elementTabPrimaryInactiveTextDefault",
  "elementTabPrimaryInactiveTextHover",
  "elementTabPrimaryInactiveBorderDefault",
  "elementTabPrimaryInactiveBorderHover",
  "elementBackgroundAvatar",
  "elementObjectiveBackgroundCompleted",
  "elementObjectiveBackgroundInProgress",
  "elementObjectiveBackgroundNotExplored",
  "alertCorrect",
  "alertNeutral",
  "alertFailure",
  "alertUp",
  "alertDown",
  "alertInfDefault",
  "alertInfDark",
  "alertInfChipDark",
  "alertInfChipLight",
  "alertSupDefault",
  "alertSupDark",
  "alertSupChipDark",
  "alertSupChipLight",
  "alertConfChipDark",
  "alertConfChipLight",
  "ressourcesFillSolo",
  "ressourcesFillDuo",
  "ressourcesFillPlaylist",
  "ressourcesFillTuto",
  "ressourcesFillWorkshop",
  "thumbnailMediaIllustrationFillNeutral",
  "thumbnailMediaIllustrationFillHover",
  "thumbnailMediaStrokeNeutral",
  "thumbnailMediaStrokeHover",
  "elementSubject1DefaultDarkBg",
  "elementSubject1DisabledDarkBg",
  "elementSubject2DefaultDarkBg",
  "elementSubject2DisabledDarkBg"
], Q = {
  backgroundColorCorrect: "#cbf9d2",
  backgroundColorIncorrect: "#ffdede",
  botBubbleColor: "#ACE4E6",
  botBubbleColorCorrect: "#408D59",
  botBubbleColorFeedback: "#FFB03B",
  botBubbleColorIncorrect: "#FF613880",
  textCorrect: "#376F40",
  textIncorrect: "#760015",
  validateBg: "#2C3E50"
}, u = {
  colorPrimary: "#007FA3",
  colorPrimaryLight: "#C7E2E8",
  colorSecondary: "#f6a532",
  colorCorrect: "#296B33",
  colorError: "#DC2020"
}, F = {
  // -- BLUE theme --
  playerCardBackgroundColor: "#6b9aea",
  playerHeaderContainerBackgroundColor: "#beccec",
  playerTextColor: "#011667",
  playerBackgroundColor: "#c9d6ed",
  playerInteractiveElementColor: "#05177c",
  playerUnopenedActivityColor: "#9cb9e9",
  playerOpenedActivityColor: "#6c98e1",
  playerClosedActivityColor: "#03187a",
  playerOpenedActivityDotColor: "#acaeff",
  playerTextColorSecondary: "#2a51a5",
  playerCorrectStrongBackgroundColor: "#C4E87D",
  playerIncorrectStrongBackgroundColor: "#F85D5D",
  playerKidFeedbackModalityTextColor: "#00166F",
  playerFeedbackBackgroundColor: "#B6D5FB",
  playerMetaFeedbackBackgroundColor: "#B6D5FB",
  playerFeedbackBorderColor: "#B6D5FB",
  choiceOverlay: "#6913AE",
  choiceTextColor: "#F7F5EE",
  selectedChoiceColor: "#F7F5EE",
  selectedChoiceTextColor: "#6913AE",
  playerGameplaySurfaceColor: "#CFE3FC",
  playerGameplayObjectColor: "#6913AE",
  playerDropzonePressColor: "#F3F1E7",
  playerTagBorderColor: "#6913AE",
  playerTagActiveBorderColor: "#6913AE",
  playerAudioColor: "#F7F5EE",
  playerAudioIconColor: "#723C00",
  // those are common to all primary schemes
  playerCorrectColor: "#99D421",
  playerIncorrectColor: "#F74A4A",
  fontFamily: "SassoonPrimaryStd",
  playerFontSize: "22px",
  playerHeaderFontSize: "18px",
  playerFontWeight: "bold"
}, G = {
  playerCardBackgroundColor: "#FFD200",
  playerHeaderContainerBackgroundColor: "#FFF4C2",
  playerTextColor: "#1A1A1A",
  playerBackgroundColor: "#FFF4C2",
  playerUnopenedActivityColor: "#FFED99",
  playerOpenedActivityColor: "#FFD200",
  playerClosedActivityColor: "#cca800",
  playerOpenedActivityDotColor: "#FFF7D1",
  playerInteractiveElementColor: "#723C00",
  playerTextColorSecondary: "#4F3D2A",
  playerKidFeedbackModalityTextColor: "#422300",
  playerFeedbackBackgroundColor: "#FDEEAC",
  playerMetaFeedbackBackgroundColor: "#FDEEAC",
  playerFeedbackBorderColor: "#FDEEAC",
  playerGameplaySurfaceColor: "#FFF4C2"
}, N = (e) => ({
  fontFamily: e.fontFamily,
  fontSize: "20px",
  pageHeaderTitleFontSize: "2.5rem",
  primaryColor: e.playerInteractiveElementColor,
  blockPage: e.playerBackgroundColor,
  blockHeader: e.playerHeaderContainerBackgroundColor,
  block: e.playerGameplaySurfaceColor,
  textMainDefault: e.playerTextColor,
  textMainOff: e.playerTextColorSecondary,
  textHeaderDefault: e.playerTextColor,
  textH1ContentPageDefault: e.playerTextColor,
  elementButtonPrimaryDefault: e.playerInteractiveElementColor,
  elementButtonPrimaryBorderDefault: e.playerInteractiveElementColor,
  elementButtonPrimaryTextDefault: e.choiceTextColor,
  elementButtonPrimaryHover: e.choiceTextColor,
  elementButtonPrimaryBorderHover: e.playerInteractiveElementColor,
  elementButtonPrimaryTextHover: e.playerInteractiveElementColor
}), X = N(F), Z = N({
  ...F,
  ...G
});
function r(e, o) {
  return e + Math.floor(o / 10 * 255).toString(16);
}
const C = "#0C224D", _ = "#322d35", s = "#FF8660", T = "#71C9FA", x = "#B1D366", t = "#ffffff", I = "#000000", h = "rgba(23, 39, 67, 0.2)", B = "#264989", ee = {
  fontFamily: "Roboto",
  fontSize: "16px",
  pageHeaderTitleFontSize: "3rem",
  primaryColor: C,
  primaryColorDark: _,
  defaultBlack: I,
  defaultWhite: t,
  blockHeader: C,
  blockFooter: C,
  blockPage: "#122D61",
  contentPage: t,
  block: "#113C72",
  blockBorder: "#113C72",
  blockItem1Default: "#134684",
  blockItem1Selected: "#12488a",
  blockItem1SelectedTeacher: s,
  blockItem1SelectedSubject1: T,
  blockItem1SelectedSubject2: x,
  blockItem1BorderDefault: r("#135CB3", 8),
  blockItem1BorderSelected: "#12488a",
  blockItem2Default: "#11316f",
  textMainDefault: t,
  textMainOff: r(t, 4),
  textMainDisabled: r(t, 2),
  textMainInverted: "#082367",
  textH1ContentPageDefault: I,
  textHeaderDefault: t,
  textFooterDefault: t,
  textSubject1Default: t,
  textSubject1Off: r(t, 2),
  textSubject1Disabled: r(t, 2),
  textSubject2Default: t,
  textSubject2Off: r(t, 2),
  textSubject2Disabled: r(t, 2),
  elementGrey10: r(t, 1),
  elementGrey20: r(t, 2),
  elementGrey50: r(t, 5),
  elementGrey80: r(t, 8),
  elementEvidencebDefault: "#AC9BFF",
  elementEvidencebDefaultLight: "#D9D1FF",
  elementEvidencebHover: t,
  elementEvidencebDisabled: r("#AC9BFF", 2.5),
  elementEvidencebIdle: h,
  elementEvidencebUnfocused: r(t, 4),
  elementTeacherDefault: s,
  elementTeacherHover: t,
  elementTeacherDisabled: r(s, 4),
  elementTeacherIdle: h,
  elementTeacherUnfocused: r(t, 4),
  elementSubject1Default: T,
  elementSubject1Hover: t,
  elementSubject1Disabled: r(T, 4),
  elementSubject1Idle: h,
  elementSubject1Unfocused: r(t, 4),
  elementSubject2Default: x,
  elementSubject2Hover: t,
  elementSubject2Disabled: r(x, 4),
  elementSubject2Idle: h,
  elementSubject2Unfocused: r(t, 4),
  elementNavigationDefault: B,
  elementNavigationHover: t,
  elementNavigationDisabled: r(C, 4),
  elementButtonPrimaryDefault: B,
  elementButtonPrimaryBorderDefault: B,
  elementButtonPrimaryTextDefault: t,
  elementButtonPrimaryHover: t,
  elementButtonPrimaryBorderHover: t,
  elementButtonPrimaryTextHover: B,
  elementButtonSecondaryDefault: "transparent",
  elementButtonSecondaryBorderDefault: t,
  elementButtonSecondaryTextDefault: t,
  elementButtonSecondaryHover: t,
  elementButtonSecondaryBorderHover: t,
  elementButtonSecondaryTextHover: B,
  elementButtonCustomHover: t,
  elementTabPrimaryActiveTextDefault: "#082367",
  elementTabPrimaryActiveTextHover: "#082367",
  elementTabPrimaryActiveBorderDefault: "#FF8660",
  elementTabPrimaryInactiveDefault: "#113C72",
  elementTabPrimaryInactiveHover: "#264989",
  elementTabPrimaryInactiveTextDefault: r(t, 8),
  elementTabPrimaryInactiveTextHover: r(t, 8),
  elementTabPrimaryInactiveBorderDefault: r(t, 5),
  elementTabPrimaryInactiveBorderHover: r(t, 5),
  elementBackgroundAvatar: t,
  elementObjectiveBackgroundCompleted: s,
  elementObjectiveBackgroundInProgress: r(s, 6),
  elementObjectiveBackgroundNotExplored: C,
  alertCorrect: "#88E688",
  alertNeutral: t,
  alertFailure: "#FF8787",
  alertUp: "#4EADF2",
  alertDown: "#FF60BA",
  alertInfDefault: "#FFA726",
  alertInfDark: "#D98A17",
  alertInfChipDark: "#4C4D3F",
  alertInfChipLight: "#FFF7EB",
  alertSupDefault: "#26A4AB",
  alertSupDark: "#3D8A8F",
  alertSupChipDark: "#205F74",
  alertSupChipLight: "#EBF8F9",
  alertConfChipDark: "#305D83",
  alertConfChipLight: "#E8F2FB",
  ressourcesFillSolo: "#0765E0",
  ressourcesFillDuo: "#5855E5",
  ressourcesFillPlaylist: "#E09452",
  ressourcesFillTuto: "#34A762",
  ressourcesFillWorkshop: "#C85757",
  thumbnailMediaIllustrationFillNeutral: r(I, 3),
  thumbnailMediaIllustrationFillHover: "linear-gradient(87.69deg, rgba(19, 92, 179, 0.26) -2.41%, rgba(67, 182, 218, 0.26) 57.99%, rgba(153, 191, 248, 0.26) 101.14%)",
  thumbnailMediaStrokeNeutral: r(t, 1),
  thumbnailMediaStrokeHover: r(t, 1),
  elementSubject1DefaultDarkBg: "#71C9FA",
  elementSubject1DisabledDarkBg: "rgba(78, 183, 242, 0.3)",
  elementSubject2DefaultDarkBg: "#B1D366",
  elementSubject2DisabledDarkBg: "rgba(177, 211, 102, 0.4)"
}, re = "#f3f5f9", y = "#073B88", te = "#322d35", A = "#FF8660", H = "#71C9FA", E = "#B1D366", n = "#ffffff", l = "#000000", D = "#E8EAEC", oe = "#F5F5F5", le = "#DBDBDB", ae = {
  fontFamily: "Roboto",
  fontSize: "16px",
  pageHeaderTitleFontSize: "3rem",
  primaryColor: y,
  primaryColorDark: te,
  defaultBlack: l,
  defaultWhite: n,
  blockHeader: n,
  blockFooter: y,
  blockPage: n,
  contentPage: n,
  block: oe,
  blockBorder: le,
  blockItem1Default: n,
  blockItem1Selected: n,
  blockItem1SelectedTeacher: A,
  blockItem1SelectedSubject1: H,
  blockItem1SelectedSubject2: E,
  blockItem1BorderDefault: "#BAC4CF",
  blockItem1BorderSelected: "#FF8660",
  blockItem2Default: "#EEF0F2",
  textMainDefault: l,
  textMainOff: r(l, 4),
  textMainDisabled: r(l, 2),
  textMainInverted: n,
  elementGrey10: r(l, 1),
  elementGrey20: r(l, 2),
  elementGrey50: r(l, 5),
  elementGrey80: r(l, 8),
  textH1ContentPageDefault: l,
  textHeaderDefault: l,
  textFooterDefault: n,
  textSubject1Default: l,
  textSubject1Off: r(l, 4),
  textSubject1Disabled: r(l, 2),
  textSubject2Default: l,
  textSubject2Off: r(l, 4),
  textSubject2Disabled: r(l, 2),
  elementEvidencebDefault: "#AC9BFF",
  elementEvidencebDefaultLight: "#D9D1FF",
  elementEvidencebHover: n,
  elementEvidencebDisabled: r("#AC9BFF", 4),
  elementEvidencebIdle: r(l, 2),
  elementEvidencebUnfocused: r(n, 2),
  elementTeacherDefault: A,
  elementTeacherHover: n,
  elementTeacherDisabled: r(A, 4),
  elementTeacherIdle: r(l, 2),
  elementTeacherUnfocused: r(n, 2),
  elementSubject1Default: H,
  elementSubject1Hover: n,
  elementSubject1Disabled: r(H, 4),
  elementSubject1Idle: r(l, 2),
  elementSubject1Unfocused: r(n, 2),
  elementSubject2Default: E,
  elementSubject2Hover: n,
  elementSubject2Disabled: r(E, 4),
  elementSubject2Idle: r(l, 2),
  elementSubject2Unfocused: r(n, 2),
  elementNavigationDefault: D,
  elementNavigationHover: n,
  elementNavigationDisabled: r(y, 4),
  elementButtonPrimaryDefault: y,
  elementButtonPrimaryBorderDefault: y,
  elementButtonPrimaryTextDefault: n,
  elementButtonPrimaryHover: n,
  elementButtonPrimaryBorderHover: y,
  elementButtonPrimaryTextHover: y,
  elementButtonSecondaryDefault: "transparent",
  elementButtonSecondaryBorderDefault: D,
  elementButtonSecondaryTextDefault: D,
  elementButtonSecondaryHover: n,
  elementButtonSecondaryBorderHover: D,
  elementButtonSecondaryTextHover: D,
  elementButtonCustomHover: "#323232",
  elementTabPrimaryActiveTextDefault: n,
  elementTabPrimaryActiveTextHover: n,
  elementTabPrimaryActiveBorderDefault: "black",
  elementTabPrimaryInactiveDefault: n,
  elementTabPrimaryInactiveHover: "#F5F5F5",
  elementTabPrimaryInactiveTextDefault: r(l, 8),
  elementTabPrimaryInactiveTextHover: r(l, 8),
  elementTabPrimaryInactiveBorderDefault: r(l, 5),
  elementTabPrimaryInactiveBorderHover: r(l, 5),
  elementBackgroundAvatar: l,
  elementObjectiveBackgroundCompleted: y,
  elementObjectiveBackgroundInProgress: r(y, 6),
  elementObjectiveBackgroundNotExplored: "#AEAEAE",
  alertCorrect: "#2A7D2B",
  alertNeutral: y,
  alertFailure: "#A41A0E",
  alertUp: "#4EADF2",
  alertDown: "#FF60BA",
  alertInfDefault: "#FFA726",
  alertInfDark: "#D98A17",
  alertInfChipDark: "#4C4D3F",
  alertInfChipLight: "#FFF7EB",
  alertSupDefault: "#26A4AB",
  alertSupDark: "#3D8A8F",
  alertSupChipDark: "#205F74",
  alertSupChipLight: "#EBF8F9",
  alertConfChipDark: "#305D83",
  alertConfChipLight: "#E8F2FB",
  ressourcesFillSolo: "#0765E0",
  ressourcesFillDuo: "#5855E5",
  ressourcesFillPlaylist: "#E09452",
  ressourcesFillTuto: "#34A762",
  ressourcesFillWorkshop: "#C85757",
  thumbnailMediaIllustrationFillNeutral: r(l, 3),
  thumbnailMediaIllustrationFillHover: re,
  thumbnailMediaStrokeNeutral: r(n, 1),
  thumbnailMediaStrokeHover: r(n, 1),
  elementSubject1DefaultDarkBg: "rgba(255, 255, 255, 0.8)",
  elementSubject1DisabledDarkBg: "rgba(255, 255, 255, 0.3)",
  elementSubject2DefaultDarkBg: "rgba(255, 255, 255, 0.8)",
  elementSubject2DisabledDarkBg: "rgba(255, 255, 255, 0.3)"
}, ne = ({
  fontAssetsDetails: e,
  type: o,
  ...a
}) => {
  const i = {}, f = {};
  Object.entries(a).forEach(([d, b]) => {
    J.includes(d) || q.includes(d) || Y.includes(d) ? f[d] = b : i[d] = b;
  }), ue(i), ie({ type: o, ...f }, e, ":root");
}, ce = (e = ":root") => {
  const o = Object.entries(L).map(([a, i]) => `--${$.kebab(a)}: ${i};`).join("");
  p(`${e} {
        ${o}
    }`), U();
}, U = () => {
  const e = (o) => Object.entries(o).map(([a, i]) => `--${$.kebab(a)}: ${i};`).join("");
  p(`.player--kid-friendly {
        ${e(F)}
        font-family: var(--font-family), sans-serif;
    }`), p(`.player--kid-friendly.player--kid-friendly-yellow {
        ${e(G)}
    }`), p(`:root:has(> body.app--kid-friendly) {
        ${e(X)}
    }`), p(`:root:has(> body.app--kid-friendly.app--kid-friendly-yellow) {
        ${e(Z)}
    }`);
}, se = (e = ":root") => {
  ce(e), ye(e);
}, ie = ({ type: e = m.Light, ...o }, a, i) => {
  const d = { ...e === m.Light ? ae : ee, ...L, ...o }, b = Object.entries(d).map(([W, R]) => `--${$.kebab(W)}: ${R};`).join("");
  p(`${i} {
        ${b}
    }`), U();
  let c, v = {};
  o.fontFamily ? (c = o.fontFamily, v = {
    light: g(
      `/fonts/${c}/${c}-Light.ttf`,
      a
    ),
    normal: g(
      `/fonts/${c}/${c}-Regular.ttf`,
      a
    ),
    medium: g(
      `/fonts/${c}/${c}-Medium.ttf`,
      a
    ),
    bold: g(
      `/fonts/${c}/${c}-Bold.ttf`,
      a
    )
  }) : (c = d.fontFamily, v = O(c, a)), j(z(c, v));
  const S = F.fontFamily;
  S !== c && j(
    z(
      S,
      O(S, a)
    )
  );
}, O = (e, o) => {
  const a = o.basePath ?? "/";
  return {
    light: `${a}fonts/${e}/${e}-Light.ttf`,
    normal: `${a}fonts/${e}/${e}-Regular.ttf`,
    medium: `${a}fonts/${e}/${e}-Medium.ttf`,
    bold: `${a}fonts/${e}/${e}-Bold.ttf`
  };
}, z = (e, o) => `
        @font-face {
            font-family: ${e};
            font-style: normal;
            font-weight: 300;
            src: url(${o.light}) format("truetype");
        }
    
        @font-face {
            font-family: ${e};
            font-style: normal;
            font-weight: 400;
            src: url(${o.normal}) format("truetype");
        }
    
        @font-face {
            font-family: ${e};
            font-style: normal;
            font-weight: 500;
            src: url(${o.medium}) format("truetype");
        }
    
        @font-face {
            font-family: ${e};
            font-style: normal;
            font-weight: 700;
            src: url(${o.bold}) format("truetype");
        }`, de = (e) => `
            --chatbot-color-bot-bubble: ${e.botBubbleColor};
            --chatbot-color-bot-bubble-correct: ${e.botBubbleColorCorrect ?? u.colorCorrect};
            --chatbot-color-bot-bubble-incorrect: ${e.botBubbleColorIncorrect ?? u.colorError};
            --chatbot-color-bot-text-correct: ${e.textCorrect ?? "var(--black)"};
            --chatbot-color-bot-text-incorrect: ${e.textIncorrect ?? u.colorError};
            --chatbot-color-background-correct: ${e.backgroundColorCorrect ?? u.colorCorrect};
            --chatbot-color-background-incorrect: ${e.backgroundColorIncorrect ?? u.colorError};
            --chatbot-color-bot-bubble-feedback: ${e.botBubbleColorFeedback};
            --chatbot-color-validate-btn: ${e.validateBg};`, ye = (e = ":root") => {
  p(`${e} {${w({})}
    }`);
}, w = (e) => `
            --color-primary: ${e.colorPrimary ?? u.colorPrimary};
            --color-primary-light: ${e.colorPrimaryLight ?? u.colorPrimaryLight};
            --color-secondary: ${e.colorSecondary ?? u.colorSecondary};
            --color-correct: ${u.colorCorrect};
            --color-incorrect: ${e.colorError ?? u.colorError};

            /* Typographical chart for gameplays */
            --color-editor-one: #CA411D;
            --color-editor-two: #155598;

            ${de(e.chatbot ?? Q)}`, ue = (e) => {
  p(`
        :root {${w(e)}
        }
    `), e.contentPagesStyle && j(e.contentPagesStyle);
}, p = (e) => {
  const o = document.createElement("style");
  o.appendChild(document.createTextNode("")), document.head.appendChild(o), o.sheet.insertRule(e, 0);
}, j = (e) => {
  const o = document.createElement("style");
  o.appendChild(document.createTextNode(e)), document.head.appendChild(o);
}, Be = ({ children: e }) => {
  const o = {
    version: "",
    contentUrl: ""
  }, [a, i] = K(
    m.Dark
  );
  return V(() => {
    (async (d) => {
      const c = {
        type: d === m.Light ? m.Light : m.Dark,
        colorPrimary: "",
        colorPrimaryLight: "",
        colorSecondary: "",
        colorSecondaryLight: "",
        colorCorrect: "",
        colorError: "",
        contentPagesStyle: ""
      };
      me(), ne({ fontAssetsDetails: o, ...c });
    })(a);
  }, [a]), /* @__PURE__ */ M("div", { style: { display: "flex", flexDirection: "column", gap: "24px" }, children: [
    /* @__PURE__ */ M("div", { style: { display: "flex", gap: "8px" }, children: [
      /* @__PURE__ */ k(
        "button",
        {
          type: "button",
          style: { padding: "16px", cursor: "pointer" },
          onClick: () => i(m.Light),
          children: "Light mode"
        }
      ),
      /* @__PURE__ */ k(
        "button",
        {
          type: "button",
          style: { padding: "16px", cursor: "pointer" },
          onClick: () => i(m.Dark),
          children: "Dark mode"
        }
      ),
      /* @__PURE__ */ k(
        "div",
        {
          style: {
            background: "var(--block)",
            width: "50px",
            height: "50px"
          }
        }
      )
    ] }),
    e
  ] });
}, me = () => {
  Array.from(document.styleSheets).forEach((o) => {
    try {
      Array.from(o.cssRules).forEach((a) => {
        if (a.selectorText === ":root") {
          const i = a.style;
          Array.from(i).forEach((f) => {
            i.removeProperty(f);
          });
        }
      });
    } catch (a) {
      console.warn("Could not access stylesheet rules:", a);
    }
  });
};
export {
  Be as T,
  m as a,
  ye as b,
  ce as c,
  se as d,
  ne as e,
  ee as f,
  Y as g,
  ae as l,
  L as p
};
//# sourceMappingURL=ThemeSwitcher-tus-5r4l.js.map
